// @flow
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import type { BlocContent } from 'types/NewsletterBloc';
import type { Status } from 'types/Status';

import { STATUS_UNKNOWN, STATUS_LOADING } from 'constants/statusConstants';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import PageNotFound from 'components/app/PageNotFound';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import { withHelmet } from 'infrastructure/seo/Helmet';

export type StateProps = {
  title: string,
  description: BlocContent[],
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  redirection: string,
  status: Status
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void
};

type HistoryProps = {
  history: any
};

type Props = {
  pageSlug: string,
  match: any
} & DispatchProps &
StateProps & HistoryProps;

class PageList extends Component<Props> {
  componentDidMount() {
    this.props.fetchPageList(this.props.pageSlug);
  }

  shouldComponentUpdate(nextProps: Props) {
    const { pageSlug } = this.props;
    if (nextProps !== this.props) {
      if (nextProps.pageSlug !== pageSlug) {
        if (nextProps.pageSlug) {
          this.props.fetchPageList(nextProps.pageSlug);
          return true;
        }
      }
      return true;
    }
    return false;
  }

  renderDescription = () => {
    const { description } = this.props;
    return description.map((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  };

  render() {
    const { title, status, redirection, match: { url } } = this.props;
    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    if (status === STATUS_UNKNOWN) {
      return <PageNotFound />;
    }
    
    if (redirection) {
      this.props.history.push(redirection);
    } else if (url && (url === '/politique-de-cookies' || url === '/politique-d-utilisation-des-sites-ffr')) {
      return <Redirect to={ '/donnees-personnelles' } />;
    }

    return (
      <React.Fragment>
        <section className="banner">
          <div className="banner__thumbnail img-green" style={{ backgroundImage: `` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
          </div>
        </section>
        <section>
          <div className="page article">
            <div className="container" style={{zIndex: '1000'}}>
              {this.renderDescription()}
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withHelmet(PageList)((Helmet, pageProps) => {
  const metaTitle = pageProps.title;

  return (
    <Helmet>
      <title>{`${metaTitle} - Fédération Française de Rugby`}</title>
      <meta name={'description'} content={metaTitle} />
      <meta property={'og:title'} content={`${metaTitle} - Fédération Française de Rugby`} />
      <meta property={'og:description'} content={metaTitle} />
    </Helmet>
  );
});
